import './Disclaimer.css';
import React from 'react';
import Page from './Page.js';

export default class Disclaimer extends React.Component {
  render() {
    return (
      <Page className="Disclaimer">
        <h1>Disclaimer<br />- Haftungsausschluss für das Webangebot des Vocalensembles Cantemus</h1>
        <h2>Inhalt des Webangebotes</h2>
        <p>
          Das Vocalensemble Cantemus ist bemüht, sein Webangebot stets aktuell und inhaltlich richtig sowie vollständig anzubieten. Dennoch ist das Auftreten von Fehlern nicht völlig auszuschließen.
        </p>
        <p>
          Das Vocalensemble Cantemus übernimmt keine Haftung für die Aktualität, die inhaltliche Richtigkeit sowie für die Vollständigkeit der in seinem Webangebot eingestellten Informationen, es sei denn die Fehler wurden vorsätzlich oder grob fahrlässig aufgenommen. Dies bezieht sich auf eventuelle Schäden materieller oder ideeller Art Dritter, die durch die Nutzung dieses Webangebotes verursacht wurden.
        </p>
        <h2>Copyright</h2>
        <p>
          Das Layout der Homepage, die verwendeten Grafiken und Bilder, die Sammlung sowie einzelnen Beiträge sind urheberrechtlich geschützt.
        </p>
        <p>
          Alle Rechte, auch die der fotomechanischen Wiedergabe, der Vervielfältigung und der Verbreitung mittels besonderer Verfahren (zum Beispiel Datenverarbeitung, Datenträger und Datennetze), auch teilweise, behält sich das Vocalensemble Cantemus vor.
        </p>
        <h2>Externe Verweise und Links</h2>
        <p>
          Mit Urteil vom 12.Mai 1998 hat das LG Hamburg entschieden, dass man durch die Ausbringung eines Links die Inhalte der gelinkten Seite ggf. mit zu verantworten hat. Dies kann, so das LG, nur dadurch verhindert werden, dass man sich ausdrücklich von diesen Inhalten distanziert.
        </p>
        <p>
          Wir haben auf unseren Seiten Links zu Seiten im Internet gelegt, deren Inhalt und Aktualisierung nicht dem Einflussbereich des Vocalensembles Cantemus unterliegen. Für alle diese Links gilt:
        </p>
        <p>
          <i>"Das Vocalensemble Cantemus hat keinen Einfluss auf Gestaltung und Inhalte fremder Internetseiten. Es distanziert sich daher von allen fremden Inhalten, auch wenn von Seiten des Vocalensembles Cantemus auf diese externe Seiten ein Link gesetzt wurde."</i>
        </p>
        <p>
          Diese Erklärung gilt für alle auf unserer Homepage angezeigten Links und für alle Inhalte der Seiten, zu denen die bei uns angemeldeten Banner und Links führen.
        </p>
        <h2>Datenschutz</h2>
        <p>
          Sofern innerhalb des Internetangebotes die Möglichkeit der Eingabe von persönlichen Daten (E-Mailadresse, Namen, Anschriften) besteht, erfolgt diese freiwillig. Das Vocalensemble Cantemus erklärt ausdrücklich, dass es diese Daten nicht an Dritte weitergibt.
        </p>
        <h2>Rechtswirksamkeit</h2>
        <p>
          Dieser Haftungsausschluss ist Teil des Internetangebotes des Vocalensembles Cantemus. Sofern einzelne Formulierungen oder Teile dieses Textes der geltenden Rechtslage nicht mehr oder nicht mehr vollständig entsprechen, bleiben die übrigen Teile dieser Erklärung davon unberührt.
        </p>
        <h1 id="part2">Disclaimer</h1>
        <h2>Contents of the Web site</h2>
        <p>
          The Vocalensemble Cantemus makes every effort to ensure that the material contained in its web site is current, complete and correct. Despite this errors and mistakes cannot be completely ruled out.
        </p>
        <p>
          The Vocalensemble Cantemus does not accept liability for the relevance, accuracy or completeness of the information and material offered in its web site unless the mistake occurred intentionally or through gross negligence. This refers to any loss, additional costs or damage of any kind suffered as a result of any use of any material in this web site.
        </p>
        <h2>Copyright</h2>
        <p>
          The Layout of the Homepage, graphics and pictures used and the collection of individual contributions are protected by copyright.
        </p>
        <p>
          The Vocalensemble Cantemus reserves all rights including the rights of photomechanical reproduction, the duplication and distribution via special processes (e.g. data processing, data carriers, data networks).
        </p>
        <h2>Links to Third Party Information</h2>
        <p>
          The verdict passed on the 12th May 1998 by the LG Hamburg rules that the inclusion of links also leads to co-responsibility of the material offered via these links. The LG Hamburg has declared that it is only possible to disclaim responsibility by expressly distancing oneself from the contents of the web sites.
        </p>
        <p>
          The Vocalensemble Cantemus web site links to third party information providers. The Vocalensemble Cantemus has no influence on the contents or reliability of the web sites of these third party information providers. The following therefore applies to all links:
        </p>
        <p>
          <i>"The Vocalensemble Cantemus has no  influence on the design and contents of third party internet web sites. The Vocalensemble Cantemus therefore expressly distances itself from the material of all third party internet web sites, even if the Vocalensemble Cantemus web site links to these external sites."</i>
        </p>
        <p>
          The declaration is valid for all links given on our web site and the material of all sites reached via banners and links on the Vocalensemble Cantemus web site.
        </p>
        <h2>Privacy</h2>
        <p>
          Where you are invited to submit personal information (e-mail address, names, postal addresses) the submission of this information is purely voluntary. The Vocalensemble Cantemus expressly declares that the information submitted will not be passed on to third parties.
        </p>
        <h2>Legal validity</h2>
        <p>
          This general disclaimer is part of the material offered in the Vocalensemble Cantemus web site. If any of the terms and conditions should be determined invalid by reason of the relevant laws then the remaining terms and conditions shall remain in full effect.
        </p>
        <p>
          In case of any uncertainties which arise due to errors in translation, the German version of this disclaimer is the legally binding one.
        </p>
      </Page>
    );
  }
}
